import { render, staticRenderFns } from "./SubmitFileEntry.vue?vue&type=template&id=31ce6533&scoped=true&"
import script from "./SubmitFileEntry.vue?vue&type=script&lang=js&"
export * from "./SubmitFileEntry.vue?vue&type=script&lang=js&"
import style0 from "./SubmitFileEntry.vue?vue&type=style&index=0&id=31ce6533&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ce6533",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BButton} from 'bootstrap-vue'
    installComponents(component, {BButton})
    


    import installDirectives from "!/Users/jurajpetras/dev/pmat/web/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installDirectives.js"
    import {VBTooltip} from 'bootstrap-vue'
    installDirectives(component, {'b-tooltip': VBTooltip})
    

export default component.exports